export const useCategoriesSummary = () => {
  const productStore = useProductsStore();

  function buildCategorySummary(items, options) {
    try {
      let _amountHolder = {};

      let allProducts = productStore.products;
      for (let i = 0; i < items.length; i++) {
        let item = items[i];

        // compare to databse
        let itemInDatabase = allProducts.find(
          (product) => product.productId === item.productId
        );
        let group = allProducts.find(
          (product) => product.productId === itemInDatabase.parentId
        );
        let category = allProducts.find(
          (product) => product.productId === group.parentId
        );

        let catCodeOrId = category?.code || category?.productId || "unknown";
        if (_amountHolder[catCodeOrId] === undefined) {
          _amountHolder[catCodeOrId] = 0;
        }
        _amountHolder[catCodeOrId] += item.amount;
      }

      if (options.rounding) {
        _amountHolder["rounding"] = options.rounding;
      }

      // place to 2 decimal
      _amountHolder = Object.fromEntries(
        Object.entries(_amountHolder).map(([key, value]) => [
          key,
          Math.round(value * 100) / 100,
        ])
      );

      return _amountHolder;
    } catch (error) {
        console.error(error);
        return {}
    }
  }

  return {
    buildCategorySummary,
  };
};
